import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import PortalLayout from './components/PortalLayout';
import LoginScreen from './screens/LoginScreen';
import SystemHealthScreen from './screens/SystemHealthScreen';
import ExecutiveScreen from './screens/ExecutiveScreen';

function RequireSuperAdmin({ children }: { children: React.ReactElement }) {
  const { isAuthenticated, isSuperAdmin } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!isSuperAdmin) {
    return (
      <PortalLayout>
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
          <h1 style={{ fontSize: '24px', color: 'var(--gray-900)', marginBottom: '8px' }}>Access Denied</h1>
          <p style={{ color: 'var(--gray-500)' }}>This portal is only available to super administrators.</p>
        </div>
      </PortalLayout>
    );
  }

  return <PortalLayout>{children}</PortalLayout>;
}

function LoginGate() {
  const { isAuthenticated, isSuperAdmin } = useAuth();
  if (isAuthenticated && isSuperAdmin) {
    return <Navigate to="/health" replace />;
  }
  return <LoginScreen />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginGate />} />
          <Route path="/health" element={<RequireSuperAdmin><SystemHealthScreen /></RequireSuperAdmin>} />
          <Route path="/executive" element={<RequireSuperAdmin><ExecutiveScreen /></RequireSuperAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
